import { render } from "./ConfermaCambioPassword.vue.vue?vue&type=template&id=c503b9c2&scoped=true"
import script from "./ConfermaCambioPassword.vue.vue?vue&type=script&lang=js"
export * from "./ConfermaCambioPassword.vue.vue?vue&type=script&lang=js"

import "./ConfermaCambioPassword.vue.vue?vue&type=style&index=0&id=c503b9c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c503b9c2"]])

export default __exports__